import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { white } from '@fiverr-private/sass/helpers';
import { MoonStarsSolidIcon } from '@fiverr-private/icons';
import {
    selectRecipientInfo,
    selectSellerName,
    selectShowNightTimeBar,
    useStaticContext
} from '../../context/contexts/static';
import { useRemoteDate } from '../../hooks';

import classes from './style.module.scss';

export const NightTimeBarNotConnected = ({ formattedTime, sellerName, drawerView }) => {
    const className = classNames(
        'tbody-7',
        classes.nightTimeBar,
        { [classes.drawerView]: drawerView }
    );

    return (
        <div className={className}>
            <MoonStarsSolidIcon color={white}/>
            <span className="m-l-8">
                <I18n k="send_message.time.night_prompt" params={{ formattedTime, sellerName }}/>
            </span>
        </div>
    );
};

NightTimeBarNotConnected.propTypes = {
    formattedTime: PropTypes.string.isRequired,
    sellerName: PropTypes.string.isRequired,
    drawerView: PropTypes.string
};

export const NightTimeBar = ({ drawerView }) => {
    const context = useStaticContext();
    const { utcOffset } = selectRecipientInfo(context);
    const { formattedTime } = useRemoteDate({ utcOffset });
    const sellerName = selectSellerName(context);
    const showNightTimeBar = selectShowNightTimeBar(context);

    if (!showNightTimeBar) {
        return null;
    }

    return <NightTimeBarNotConnected formattedTime={formattedTime} sellerName={sellerName} drawerView={drawerView}/>;
};

NightTimeBar.propTypes = {
    drawerView: PropTypes.string
};
